module.exports = __webpack_public_path__ + "img/link-arrow-circle-right.3fffa225.svg";